const disciplineActionsCode = {
  UnSet: 0,
  IAES: 175,
  HearingRemoval: 176,
  OutOfSchoolSuspension: 177,
  InSchoolSuspension: 178,
};

export default disciplineActionsCode;
